/* eslint-disable import/prefer-default-export */

export const MENUS = {
  personnel: 'can-view-personnel-page',
  regularContractorF30: 'can-view-regular-contractor-f30-page',
  store: 'can-view-area-section-store-page',
  area: 'can-view-area-section-area-page',
  sectionVehicles: 'can-view-area-section-vehicles-page',
};
